<template>
  <div>
    <span v-if="!item.val || !item.val.length" class="nodata">
      {{ noData }}
      <div class="black-class" v-show="!item.dataCompare">
        {{ item.oldValArr }}
      </div>
    </span>
    <span v-else>
      <span
        v-for="(val, index) in item.val"
        :title="val.title"
        style="font-size: 14px"
        :class="{ add: val.type == 'add', manufact: val.link }"
        :key="index"
        @click="listClick(val)"
      >
        {{ val.title }}
      </span>
      <div v-show="!item.dataCompare">
        <span
          v-for="(val, index) in item.oldValArr"
          :class="{ del: val.type == 'del', manufact: val.link }"
          :title="val.title"
          style="font-size: 14px; color: black"
          :key="index"
          @click="listClick(val)"
        >
          {{ val.title }}
        </span>
      </div>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      noData: this.$t("message.tips.noData"),
      item: {},
    };
  },
  props: ["data"],
  methods: {
    listClick(item) {
      if (!item.link) {
        return;
      }
      axios
        .get("pmdm/admin/list/getObjectInfoByListId?listEntryId=" + item.id)
        .then((res) => {
          console.log(res);
          const obj = { ...res.data.object, title: item.title };
          this.getLink(obj);
          this.$store.commit("setPageRefresh");
        });
    },
    setData(data) {
      let obj = {};
      if (data.uiType != 4) {
        const obj = {
          title: data.oldVal,
          type: data.dataCompare ? "" : "del",
        };
        data.oldValArr = [obj];
        if (data.val) {
          const [newVal] = data.val;
          newVal.type = data.dataCompare ? "" : "add";
        }
        return data;
      }

      const list = data.val || [];
      const oldArr = data.oldVal.split(";");
      const newArr = list.map((i) => i.title);
      const oldValArr = oldArr.map((i, e) => {
        let title = "",
          type = "";
        if (newArr.includes(i)) {
          type = "";
        } else {
          type = "del";
          title = e === oldArr.length - 1 ? i : i + " ;";
        }
        return { title, type };
      });

      const val = list.map((i, e) => {
        i.type = !oldArr.includes(i.title) ? "add" : "";
        if (e !== list.length - 1) {
          i.title += ";";
        }
        return i;
      });
      obj = { ...data, oldValArr, val };
      return obj;
    },
  },
  mounted() {
    this.item = this.setData(this.data);
    // this.$nextTick(() => {
    //   this.$forceUpdate();
    // });

    // if (this.item.uiType == 4) {
    //   console.log(this.item);
    // }
  },
};
</script>

<style scoped>
.black-class {
  text-decoration: line-through red;
  color: #000;
}

.del {
  text-decoration: line-through red;
  color: #000;
}

.add {
  color: red;
}
</style>
